(function(){
  /**
   * Try to format gender using the EdEx conventional display name for the gender.
   */
  angular.module('core').filter('edxGender', ['settingsApi',
      function(settingsApi) {
          var genders = settingsApi.getGenders();
          var genderByCode = _.indexBy(genders, function(g) { return g.code; });
          return function(gender) {
              var genderObj = genderByCode[gender];
              if (genderObj) {
                return genderObj.name;
              } else {
                return '';
              }
          };
      }
  ]);
})();